import Vue from 'vue'
import App from './App.vue'
import Axios from 'axios'
import router from './router'
import store from '@/store'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import VueLayers from 'vuelayers'
import 'vuelayers/lib/style.css' // needs css-loader

import Notifications from 'vue-notification'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'

import VueApexCharts from 'vue-apexcharts'

//Register global apexchart
Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)

// Install BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)
//Plugin de notificaiones
Vue.use(Notifications)
// Agregado soporte de VUEX
Vue.use(store)
// Configuracion de VueLayers
Vue.use(VueLayers, {
  // global data projection, see https://vuelayers.github.io/#/quickstart?id=global-data-projection
  // dataProjection: 'EPSG:4326',
})

//Vue-moment formateo de fechas - https://github.com/brockpetrie/vue-moment#configuration
const moment = require('moment')
require('moment/locale/es')
Vue.use(require('vue-moment'), {
  moment
})


// Axios config
Vue.prototype.$http = Axios;
Vue.config.productionTip = false


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
